module.exports = __webpack_public_path__ + "img/metamask.6371bef8.png";